const dietaryOptions = [
  { value: 'vegan', label: 'Vegan' },
  { value: 'vegetarian', label: 'Vegetarian' },
  { value: 'kosher', label: 'Kosher' },
  { value: 'gluten-free', label: 'Gluten-free' },
  { value: 'dairy-free', label: 'Dairy-free' },
  { value: 'nut-free', label: 'Nut-free' },
];

function DietaryRequirements({ dietary, dietaryOther, name = 'dietary', onChange }) {
  function handleCheckboxChange(e) {
    const { value, checked } = e.target;
    const updated = checked
      ? [...dietary, value]
      : dietary.filter(d => d !== value);
    onChange({ dietary: updated, dietaryOther });
  }

  function handleOtherChange(e) {
    onChange({ dietary, dietaryOther: e.target.value });
  }

  return (
    <div className="content">
      <h2 className="josefin-slab upper">Dietary requirements</h2>

      <div className="rsvp-options rsvp-options-two-col">
        {dietaryOptions.map(({ value, label }) => (
          <label key={value} className="josefin-slab rsvp-label">
            <input type="checkbox" name={name} value={value} checked={dietary.includes(value)} onChange={handleCheckboxChange} />
            {label}
          </label>
        ))}
        <label className="josefin-slab rsvp-label">
          Other (please tell us more):
          <textarea name={`${name}-other`} className="josefin-slab rsvp-textarea" rows="3" value={dietaryOther} onChange={handleOtherChange} />
        </label>
      </div>
    </div>
  );
}

export default DietaryRequirements;
